// Make it a react component:

// When the image source is loaded, the image height is set to auto.
// When the image source is not loaded, a placeholder div with a fixed height is shown. I want it to use a fixed width/height ratio.

import React, { useState } from 'react';

export const BannerImage = ({ 
  src, 
  alt, 
  className, 
  style,  
  aspectRatio = '1288/529',
}: { 
  src: string; 
  alt: string; 
  className?: string; 
  style?: React.CSSProperties; 
  aspectRatio?: string; 
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';
    return (
        <>
            <div style={{ width: '100%', height: 'auto', 
                ...isLoaded ? {} : { aspectRatio: aspectRatio }, 
            ...style }}>
                <img
                    src={`${locateSrc}${src}`}
                    alt={alt}
                    className={className}
                    style={{ height: isLoaded ? 'auto' : '100%', display: isLoaded ? 'inline-block' : 'none' }}
                    onLoad={() => setIsLoaded(true)}
                />
            </div>
        </>
    );
}